import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import { Label } from '../../fields/label';

import styles from './FilesList.module.scss';

const FilesList = ({ className, label, children }) => {
  return (
    <div className={classnames(className)}>
      {label && <Label className="mb-2">{label}</Label>}
      <div className={styles.list}>{children}</div>
    </div>
  );
};

FilesList.propTypes = {
  label: PropTypes.node,
};

export default FilesList;
